(function () {
  var mappings = window.LBD_HERO_VARIANTS || {};
  var scheduled = false;

  function productHandle(url) {
    try {
      var path = new URL(url, window.location.href).pathname;
      return path.indexOf('/products/') === -1 ? '' : path.split('/products/')[1].split('/')[0];
    } catch (_error) {
      return '';
    }
  }

  function updateLink(link, mapping) {
    var url = new URL(link.href, window.location.href);
    url.searchParams.set('variant', mapping.variantId);
    link.href = url.toString();
  }

  function updateImage(image, mapping) {
    if (!image || !mapping.imageUrl) return;
    if ((image.currentSrc || image.src).indexOf(mapping.imageName) === -1) image.src = mapping.imageUrl;
    image.alt = mapping.alt;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    var picture = image.closest('picture');
    if (picture) {
      Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('sizes');
      });
    }
  }

  function sync() {
    scheduled = false;
    var grouped = {};
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="/products/"]'), function (link) {
      var handle = productHandle(link.href);
      if (!mappings[handle]) return;
      if (!grouped[handle]) grouped[handle] = [];
      grouped[handle].push(link);
    });

    Object.keys(grouped).forEach(function (handle) {
      var mapping = mappings[handle];
      grouped[handle].forEach(function (link) {
        updateLink(link, mapping);
        var card = link.closest('[data-product-id], product-card, .product-card, .card-product, .resource-card');
        var image = (card || link).querySelector('img') || link.querySelector('img');
        updateImage(image, mapping);
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

